import PropTypes from "prop-types";
import React from "react";

import { Container, CssBaseline, useMediaQuery, useScrollTrigger } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import Banner from "../shared/Banner";
import Footer from "../shared/Footer";
import MainHeader from "../shared/MainHeader";
import ScrollTop from "../../components/_common/BackToTop";

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        padding: theme.spacing(0, 2, 2, 2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(0, 1, 0, 0),
        },
    },
}));

function ElevationScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 20,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.element.isRequired,
};

const HomeView = (props) => {
    const classes = useStyles();
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"));

    return (
        <React.Fragment>
            <div id="back-to-top-anchor" />
            <Container maxWidth={false}>
                <CssBaseline />
                <>
                    <Banner isMobile={isMobile} />

                    <ElevationScroll {...props}>
                        <MainHeader isMobile={isMobile} />
                    </ElevationScroll>
                </>

                <Container maxWidth={"lg"} className={classes.mainContainer} id={"the-main-container"}>
                    {props.children}
                </Container>
            </Container>

            <Footer isMobile={isMobile} />

            <ScrollTop />

        </React.Fragment>
    );
};

export default HomeView;
